import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppSettings } from '../app.settings';

import { CorporateActions } from '../transaction-store/corporate-matching';

@Component({
  selector: 'app-double-the-donation',
  template: `
    <section class="container">
      <h2 class="section-title">See if your employer will match your donation!</h2>
      <div class="row">
        <div id="dd-company-name-input" class="col-12"></div>
      </div>
    </section>
  `
})
export class DoubleTheDonationComponent implements OnInit {
  constructor(
    private settings: AppSettings,
    private store: Store,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {
      // Append API key string to the element for DTD to properly render any custom messaging.
      const apiKey = this.settings.getValue('organization').details[
        'doublethedonation.public_key'
      ];
      const scriptNode = document.createElement('script');
      scriptNode.innerHTML = `var DDCONF = {API_KEY: "${apiKey}"};`;
      this.renderer.appendChild(this.elementRef.nativeElement, scriptNode);
    }

  ngOnInit() {
    // for Thank You modal, we need to manually trigger the input. Not sure if
    // there is an indicator that we are in the modal, but calling the js
    // method manually doesn't seem to affect anything.
    if (window['doublethedonation']) {
      window['doublethedonation'].plugin.load_streamlined_input();
    }

    const listener = (payload: any) => {
      this.store.dispatch(new CorporateActions.SetCorporate(payload.detail));
    };

    document.addEventListener('doublethedonation_company_id', listener);
  }
}
